import { LoginStateProps } from '../type';

const loginState: LoginStateProps = {
  isSuccess: false,
  isUserAuthenticated: false,
  userData: null,
};

const initialState = {
  loginState: { ...loginState },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function loginReducer(state = initialState, action: any) {
  switch (action.type) {
    case 'START_LOADER':
      return {
        ...state,
        isLoading: true,
      };
    case 'STOP_LOADER':
      return {
        ...state,
        isLoading: false,
      };
    case 'USER_ACTION':
      return {
        ...state,
        loginState: {
          isSuccess: true,
          isUserAuthenticated: true,
          userData: action.payload,
        },
      };
    default:
      return state;
  }
}
